
import { defineComponent, PropType } from 'vue'
import QDialog from 'quasar/src/components/dialog/QDialog.js';import QCard from 'quasar/src/components/card/QCard.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';;

export default defineComponent({
    components: {
        QDialog,
        QCard,
        QBtn,
    },
    emits: [
        ...useDialogPluginComponent.emits,
    ],
    setup() {
        const { dialogRef, onDialogHide } = useDialogPluginComponent();
        return { dialogRef, onDialogHide }
    },
    props: {
        guesses: {
            required: true,
            type: Object as PropType<string[]>,
        },
        squareEmojis: {
            required: true,
            type: String,
        }
    },
    methods: {
        hide() {
            this.dialogRef?.hide();
        }
    }
})
